// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  playerBotTag,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
  teamsGrouped,
  teamStandings,
  activeSynergyForSpell,
} from "../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../util";
import { uiFont, voidNameGradient } from "../ui-tokens";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../audio";
import {
  drawBarIcon,
} from "../spell-icons";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  spellBarTipHTML,
  scheduleTipMove,
  tipAttr,
} from "../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../lobby";

import { Game } from "./game-base";
import { updateStatusFxHud } from "../status-fx";

Game.prototype.shouldDrawScoreboard = function () {
    if (this.scoreboardHeld) return true;
    if (!this.scoreboardOpen) return false;
    return this.scoreboardDockVisible();
  }

Game.prototype.scoreboardDockVisible = function () {
    return this.state === "playing" || this.state === "countdown" || this.state === "roundover";
  }

Game.prototype.fmtReconnectCountdown = function (sec) {
    const s = Math.max(0, Math.ceil(sec || 0));
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${m}:${String(r).padStart(2, "0")}`;
  }

Game.prototype.effectiveDcLeft = function (pl) {
    if (!pl.dcGrace || !(pl.dcLeft > 0) || !pl.dcLeftAt) return 0;
    return Math.max(0, pl.dcLeft - (performance.now() - pl.dcLeftAt) / 1000);
  }

// Left standings row: name, wins, optional (bot) / (disconnected) suffix.
Game.prototype.drawPlayerStandingRow = function (c, pl, x, y, labelOverride, nameColor) {
    const baseName = labelOverride ?? (pl.isHuman ? "You" : (pl.colorName || pl.name || ""));
    const label = baseName;
    c.font = uiFont(600, "md");
    c.textBaseline = "top";
    c.textAlign = "left";

    const wins = "★".repeat(pl.wins || 0);
    const base = wins ? `${label}  ${wins}` : label;
    const strike = !!pl.dcGone;
    const baseW = c.measureText(base).width;
    if (!strike && pl.admin) c.fillStyle = voidNameGradient(c, x, baseW);
    else c.fillStyle = strike ? "#6b6690" : (nameColor || (pl.alive ? "#fff" : "#6b6690"));
    c.fillText(base, x, y);

    if (strike) {
      const mid = y + 9;
      c.strokeStyle = "rgba(107,102,144,0.9)";
      c.lineWidth = 1;
      c.beginPath();
      c.moveTo(x, mid);
      c.lineTo(x + baseW, mid);
      c.stroke();
    }

    let tag = null;
    if (pl.dcGone || pl.dcGrace) tag = "(disconnected)";
    else if (pl.isBot) tag = playerBotTag(pl).trim();

    if (!tag) return;

    const tail = x + baseW + 6;
    c.font = uiFont(600, "sm");
    c.fillStyle = pl.dcGone ? "#6b6690" : "#9a93c0";
    c.fillText(tag, tail, y + 1);

    if (pl.dcGrace && !pl.dcGone) {
      const rem = this.effectiveDcLeft(pl);
      if (rem > 0) {
        const cdX = tail + c.measureText(tag).width + 8;
        c.fillStyle = rem <= 15 ? "#ff9a5a" : "#7ec8e3";
        c.fillText(this.fmtReconnectCountdown(rem), cdX, y + 1);
      }
    }
  }

// Left standings row for team matches: "Team N" + win stars.
Game.prototype.drawTeamStandingRow = function (c, row, x, y) {
    const label = `Team ${row.team}`;
    c.font = uiFont(600, "md");
    c.textBaseline = "top";
    c.textAlign = "left";
    c.fillStyle = teamColor(row.team);
    c.fillRect(x - 18, y + 2, 12, 12);
    const wins = "★".repeat(row.wins || 0);
    c.fillStyle = "#fff";
    c.fillText(wins ? `${label}  ${wins}` : label, x, y);
  }

Game.prototype.drawStandingsBlock = function (c, x, y, eyeId) {
    if (teamsGrouped(this.players)) {
      for (const row of teamStandings(this.players)) {
        this.drawTeamStandingRow(c, row, x, y);
        y += 20;
      }
      return y;
    }
    for (const pl of this.players) {
      if (pl.boss || pl.bossAdd || pl.dummy) continue;
      const watching = pl.id === eyeId;
      c.fillStyle = pl.robe;
      c.fillRect(14, y + 2, 12, 12);
      let tx = x;
      if (watching) {
        c.font = uiFont(400, "base");
        c.fillStyle = "#7ec8e3";
        c.fillText("👁", 30, y + 1);
        tx = 50;
        c.font = uiFont(600, "md");
      }
      const nameColor = watching ? "#d8f4ff" : null;
      this.drawPlayerStandingRow(c, pl, tx, y, pl.isHuman ? "You" : (pl.colorName || pl.name), nameColor);
      y += 20;
    }
    return y;
  }

Game.prototype.shouldAnchorToastAboveHud = function () {
    return !this.isAtMenu() || this.spectating;
  }

Game.prototype.layoutToastStack = function () {
    const stack = document.getElementById("toastStack");
    if (!stack) return;
    if (!stack.querySelector(".achievement-toast") || !this.shouldAnchorToastAboveHud()) {
      stack.style.top = "";
      stack.style.right = "";
      stack.style.bottom = "";
      return;
    }
    const hud = this.matchHudCorner();
    const gap = 8;
    const vh = window.visualViewport?.height ?? window.innerHeight;
    stack.style.top = "auto";
    stack.style.right = "16px";
    stack.style.bottom = `${Math.round(vh - hud.toggleTop + gap)}px`;
  }

Game.prototype.updateScoreboardToggle = function () {
    const btn = document.getElementById("scoreboardToggle");
    if (!btn) return;
    const show = this.scoreboardDockVisible();
    btn.classList.toggle("hidden", !show);
    const hud = this.matchHudCorner();
    btn.style.right = "16px";
    btn.style.left = "auto";
    btn.style.top = `${hud.toggleTop}px`;
    if (show) {
      const open = this.scoreboardHeld || this.scoreboardOpen;
      btn.textContent = open ? "Scores ▾" : "Scores ▸";
      btn.title = open
        ? "Hide scoreboard (Tab still shows while held)"
        : "Show scoreboard (or hold Tab)";
    }
    this.layoutToastStack();
  }

Game.prototype.drawScoreboard = function () {
    const c = this.ctx;
    const place = this.state === "roundover";
    const grouped = teamsGrouped(this.players);
    const rows = grouped
      ? teamStandings(this.players).flatMap(row => row.members.map((m, i) => ({
          ...m,
          teamWins: row.wins,
          teamRow: row.team,
          showTeamWins: i === 0,
        })))
      : [...this.players];
    rows.sort((a, b) => place
      ? ((a.lastPlacement || 99) - (b.lastPlacement || 99))
      : grouped
        ? ((b.teamWins - a.teamWins) || (a.teamRow - b.teamRow) || ((b.kills - a.kills) || ((b.dmgDealt || 0) - (a.dmgDealt || 0))))
        : ((b.wins - a.wins) || (b.kills - a.kills) || ((b.dmgDealt || 0) - (a.dmgDealt || 0))));
    const cols = [];
    if (place) cols.push({ k: "place", label: "PLACE", w: 66, align: "left" });
    cols.push(
      { k: "name", label: grouped ? "TEAM" : "WARLOCK", w: 196, align: "left" },
      { k: "wins", label: grouped ? "TEAM WINS" : "WINS", w: 70, align: "right" },
      { k: "kills", label: "KO", w: 52, align: "right" },
      { k: "deaths", label: "DEATHS", w: 76, align: "right" },
      { k: "dmgDealt", label: "DMG", w: 78, align: "right" },
      { k: "dmgTaken", label: "TAKEN", w: 78, align: "right" },
      { k: "healDone", label: "HEAL", w: 70, align: "right" },
    );
    const padX = 22, rowH = 30, headH = 38, titleH = 34;
    const tableW = cols.reduce((s, col) => s + col.w, 0);
    const w = tableW + padX * 2;
    const h = titleH + headH + rows.length * rowH + 18;

    // While a round is live (spectating after death, or holding Tab) dock the
    // board to the right edge so the arena stays visible instead of being covered.
    // Round-over stays centered with its big result headline.
    const side = this.state === "playing";

    // Round-over: draw a big result headline above the table (and a "continue"
    // hint below for offline play), then center the whole stack as one group so
    // it sits in the middle of the screen instead of clinging to the top edge.
    const resultText = place ? (this.roundResultText || "") : "";
    const resultH = resultText ? 72 : 0;
    const canSkip = place && this.mode !== "remote";
    const hintH = canSkip ? 36 : 0;
    const groupH = resultH + h + hintH;

    let x, y, top;
    if (side) {
      x = Math.round(this.W - w - 16);
      top = this.inSpectateView() ? CFG.scoreboardSideTopSpec : CFG.scoreboardSideTop;
      y = top;
    } else {
      x = Math.round(this.cx - w / 2);
      top = Math.round(Math.max(24, this.cy - groupH / 2));
      y = top + resultH;
    }

    c.save();
    // shrink to fit narrow screens (phones) without distorting
    if (side) {
      const fit = Math.min(1, (this.W - 32) / w, (this.H - 32) / h);
      if (fit < 1) { const ax = x + w; c.translate(ax, top); c.scale(fit, fit); c.translate(-ax, -top); }
    } else {
      const maxGroupH = (window.visualViewport?.height || window.innerHeight) * 0.9;
      const availH = Math.min(this.H - 32, maxGroupH);
      const fit = Math.min(1, (this.W - 20) / w, availH / groupH);
      if (fit < 1) { const fy = top + groupH / 2; c.translate(this.cx, fy); c.scale(fit, fit); c.translate(-this.cx, -fy); }
    }

    if (resultText) {
      c.textAlign = "center";
      c.textBaseline = "middle";
      c.fillStyle = /WIN/i.test(resultText) ? "#ffd479" : "#cbb6ff";
      c.font = uiFont(800, "2xl");
      c.shadowColor = "rgba(0,0,0,0.6)"; c.shadowBlur = 12;
      c.fillText(resultText, this.cx, top + resultH / 2 - 4);
      c.shadowBlur = 0;
    }

    c.fillStyle = "rgba(8,9,20,0.86)";
    c.strokeStyle = "rgba(150,140,220,0.35)";
    c.lineWidth = 1.5;
    c.beginPath(); c.roundRect(x, y, w, h, 12); c.fill(); c.stroke();

    c.textBaseline = "middle";
    c.font = uiFont(700, "md");
    c.textAlign = "center";
    c.fillStyle = "#cfc7ef";
    c.fillText("SCOREBOARD", x + w / 2, y + titleH / 2 + 4);

    // header
    let hy = y + titleH + headH / 2;
    c.font = uiFont(700, "xs");
    c.fillStyle = "#8a83b8";
    let cx = x + padX;
    for (const col of cols) {
      c.textAlign = col.align;
      const tx = col.align === "left" ? cx + 22 : cx + col.w;
      c.fillText(col.label, tx, hy);
      cx += col.w;
    }
    c.strokeStyle = "rgba(150,140,220,0.18)";
    c.beginPath(); c.moveTo(x + padX, y + titleH + headH); c.lineTo(x + w - padX, y + titleH + headH); c.stroke();

    // rows
    let ry = y + titleH + headH;
    for (const r of rows) {
      const cy2 = ry + rowH / 2;
      if (r.isHuman) {
        c.fillStyle = "rgba(110,100,200,0.18)";
        c.fillRect(x + padX - 6, ry + 2, tableW + 12, rowH - 4);
      }
      let colX = x + padX;
      for (const col of cols) {
        c.textAlign = col.align;
        if (col.k === "place") {
          c.fillStyle = (r.lastPlacement === 1) ? "#ffd479" : "#b6afdc";
          c.font = uiFont(700, "base");
          c.fillText(ordinal(r.lastPlacement || 0), colX, cy2);
        } else if (col.k === "name") {
          c.textBaseline = "middle";
          if (grouped) {
            c.fillStyle = teamColor(r.teamRow);
            c.fillRect(colX, cy2 - 7, 14, 14);
            const member = r.isHuman ? "You" : (r.colorName || r.name || "");
            const label = r.showTeamWins ? `Team ${r.teamRow} · ${member}` : `↳ ${member}`;
            c.fillStyle = r.isHuman ? "#fff" : "#d6d0f0";
            c.font = uiFont(600, "base");
            c.fillText(label, colX + 22, cy2);
          } else {
            c.fillStyle = r.robe;
            c.fillRect(colX, cy2 - 7, 14, 14);
            c.textBaseline = "top";
            this.drawPlayerStandingRow(c, r, colX + 22, cy2 - 7,
              r.isHuman ? "You" : (r.colorName || r.name || ""));
            c.textBaseline = "middle";
          }
        } else {
          let v = r[col.k] || 0;
          if (col.k === "wins") {
            c.fillStyle = "#ffd479";
            if (grouped) {
              v = r.showTeamWins ? ("★ " + (r.teamWins || 0)) : "—";
            } else {
              v = "★ " + v;
            }
          } else { c.fillStyle = "#d6d0f0"; v = Math.round(v); }
          c.font = uiFont(600, "base");
          c.fillText(v, colX + col.w, cy2);
        }
        colX += col.w;
      }
      ry += rowH;
    }
    if (canSkip) {
      c.textAlign = "center";
      c.textBaseline = "middle";
      c.font = uiFont(600, "base");
      c.fillStyle = "rgba(190,182,224,0.72)";
      c.fillText("Press any key to continue", this.cx, y + h + hintH / 2);
    }
    c.restore();
  }

Game.prototype.drawHUD = function () {
    const c = this.ctx;
    const bossWarn = this.collectBossWarnings(this.human());
    if (this.inSpectateView()) {
      this.drawSpectatorHUD();
      updateStatusFxHud(this);
      return;
    }
    const p = this.human();
    if (!p) return;

    // top bar: round + wins + alive count
    c.save();
    c.font = uiFont(600, "md");
    c.textBaseline = "top";

    // round indicator center-top
    c.textAlign = "center";
    c.fillStyle = "#b6afdc";
    if (this.matchMode === "sandbox") {
      const parts = [];
      if (this.sandboxDummyCount) parts.push("Dummy");
      if (this.sandboxDumbCount) parts.push(`${this.sandboxDumbCount} Dumb`);
      if (this.sandboxSmartCount) parts.push(`${this.sandboxSmartCount} Smart`);
      const label = parts.length ? parts.join(" · ") : "Arena";
      c.fillText(`SANDBOX — ${label}`, this.cx, 14);
    } else if (this.matchMode === "pve") {
      const twinFight = this.pveBossId === "sisters";
      const boss = twinFight
        ? this.players.find(pl => pl.boss === "morwenna" && pl.alive && !pl.bossAdd)
        : this.players.find(pl => pl.boss && pl.alive && !pl.bossAdd);
      const bossLabel = twinFight ? "THE TWIN SISTERS" : pveBossName(this.pveBossId || (boss && boss.boss)).toUpperCase();
      c.fillText(`BOSS ${this.roundNumber} / ${this.matchRounds} — ${bossLabel}`, this.cx, 14);
      if (boss && boss.alive) {
        const max = boss.maxHP || boss.effMaxHP();
        const frac = clamp(boss.hp / max, 0, 1);
        const pct = Math.round(frac * 100);
        const bw = Math.min(420, this.W * 0.55), bh = 14;
        const bx = this.cx - bw / 2, by = 36;
        c.fillStyle = "rgba(0,0,0,0.55)";
        c.fillRect(bx - 1, by - 1, bw + 2, bh + 2);
        c.fillStyle = "#5a2040";
        c.fillRect(bx, by, bw, bh);
        c.fillStyle = frac > 0.3 ? "#e85d8a" : "#ff2244";
        c.fillRect(bx, by, bw * frac, bh);
        c.strokeStyle = "rgba(255,255,255,0.25)";
        c.lineWidth = 1;
        c.strokeRect(bx, by, bw, bh);
        c.font = uiFont(700, "xs");
        c.textBaseline = "middle";
        c.fillStyle = "#fff";
        c.fillText(`${pct}%`, this.cx, by + bh / 2 + 0.5);
        c.font = uiFont(600, "xs");
        c.fillStyle = "#c9b8e8";
        c.textBaseline = "top";
        c.fillText(`${Math.ceil(boss.hp).toLocaleString()} / ${Math.ceil(max).toLocaleString()} HP`, this.cx, by + bh + 4);
        const mirrorCourt = this.pveBossId === "kael" && this.players.some(pl => pl.mirrorAdd && pl.alive);
        if (mirrorCourt) {
          const pulse = 0.85 + 0.15 * Math.sin(this.nowS * 7);
          c.save();
          c.globalAlpha = pulse;
          c.font = uiFont(700, "sm");
          c.fillStyle = "rgba(0,0,0,0.55)";
          c.fillText("MIRROR COURT — STRIKE THE TRUE KAEL", this.cx + 1, by + bh + 23);
          c.fillStyle = "#c090ff";
          c.fillText("MIRROR COURT — STRIKE THE TRUE KAEL", this.cx, by + bh + 22);
          c.font = uiFont(600, "xs");
          c.fillStyle = "#a080d0";
          c.fillText("Only the real Kael keeps the arcane sigil beneath him.", this.cx, by + bh + 38);
          c.restore();
        }
        if (boss.boss === "groshkar" && boss.gorgeStacks > 0) {
          const cap = 10;
          const stacks = boss.gorgeStacks;
          let gy = by + bh + 22;
          const pipW = 14, pipGap = 4, pipH = 10;
          const totalW = cap * pipW + (cap - 1) * pipGap;
          const gx = this.cx - totalW / 2;
          c.font = uiFont(700, "xs");
          c.fillStyle = "#a8c860";
          c.fillText(`GORGE ×${stacks}`, this.cx, gy);
          gy += 14;
          for (let i = 0; i < cap; i++) {
            c.fillStyle = i < stacks ? "#c8d040" : "rgba(106,138,48,0.35)";
            c.fillRect(gx + i * (pipW + pipGap), gy, pipW, pipH);
          }
          c.font = uiFont(600, "xs");
          c.fillStyle = "#8aa840";
          c.fillText("Feeding — heals & faster. Keep your distance.", this.cx, gy + pipH + 6);
        }
        if (boss.castLabel && !bossWarn.primary) {
          const sp = SPELLS[boss.castLabel];
          const label = (sp && sp.name) || boss.castLabel;
          const col = (sp && sp.color) || "#c8d040";
          const pulse = 0.88 + 0.12 * Math.sin(this.nowS * 9);
          const castY = boss.boss === "groshkar" && boss.gorgeStacks > 0 ? by + bh + 78 : by + bh + 28;
          c.save();
          c.globalAlpha = pulse;
          c.font = uiFont(800, "md");
          c.fillStyle = "rgba(0,0,0,0.55)";
          c.fillText(label.toUpperCase(), this.cx + 1, castY + 1);
          c.fillStyle = col;
          c.fillText(label.toUpperCase(), this.cx, castY);
          c.restore();
        } else if (boss.channelSpell && SPELLS[boss.channelSpell] && !bossWarn.primary) {
          const sp = SPELLS[boss.channelSpell];
          const cp = clamp(boss.channelProg || 0, 0, 1);
          const castY = boss.boss === "groshkar" && boss.gorgeStacks > 0 ? by + bh + 78 : by + bh + 28;
          const pulse = 0.85 + 0.15 * Math.sin(this.nowS * 10);
          c.save();
          c.globalAlpha = pulse;
          c.font = uiFont(800, "md");
          c.fillStyle = "rgba(0,0,0,0.55)";
          c.fillText(sp.name.toUpperCase(), this.cx + 1, castY + 1);
          c.fillStyle = sp.color || "#e8f4ff";
          c.fillText(sp.name.toUpperCase(), this.cx, castY);
          if (cp > 0) {
            const barW = Math.min(200, bw * 0.55);
            const barX = this.cx - barW / 2;
            c.fillStyle = "rgba(0,0,0,0.45)";
            c.fillRect(barX, castY + 16, barW, 4);
            c.fillStyle = sp.color || "#a8d4f0";
            c.fillRect(barX, castY + 16, barW * cp, 4);
          }
          c.restore();
        }
      }
    } else {
      c.fillText(`ROUND ${this.roundNumber} / ${this.matchRounds}`, this.cx, 14);
    }
    c.font = uiFont(600, "md");
    c.textBaseline = "top";
    // Boss telegraphs + debuff chips — one unified, consistent component
    // (primary banner + stacked debuff chips). See render/boss-warning.ts.
    this.drawBossWarnings(c, bossWarn);
    // shrink warning (staged)
    if (this.state === "playing" && this.matchMode !== "sandbox") {
      const ss = shrinkState(this.roundTime, this.matchMode);
      const warnY = this.matchMode === "pve" ? 124 : 34;
      if (ss.phase === "shrinking") {
        c.fillStyle = "#ff6a3a";
        c.fillText("⚠ THE VOID IS CLOSING IN ⚠", this.cx, warnY);
      } else if (ss.phase === "pre" || ss.phase === "hold") {
        c.fillStyle = "#ff9a5a";
        c.fillText(`The void closes in… ${Math.ceil(ss.nextIn)}`, this.cx, warnY);
      }
    }

    // wins standings top-left (below center round title)
    c.textAlign = "left";
    let y = CFG.hudWinsBaseY;
    this.drawStandingsBlock(c, 32, y);

    // gold + damage — top-right corner stack (ping sits above in DOM)
    const hud = this.matchHudCorner();
    const rx = this.W - 16;
    c.textAlign = "right";
    if (hud.goldY != null) {
      c.fillStyle = "#ffd479";
      c.font = uiFont(600, "md");
      c.fillText(`✦ ${p.gold}g`, rx, hud.goldY);
    }
    c.fillStyle = "#ff9a5a";
    c.font = uiFont(600, "base");
    c.fillText(`DMG ${Math.round(p.dmgDealt || 0)}  ·  ${p.kills || 0} KO`, rx, hud.dmgY);
    c.restore();

    // spell cooldown bar bottom-center
    this.drawSpellBar(p);
    updateStatusFxHud(this);
  }

Game.prototype.drawSpectatorHUD = function () {
    if (this.spectating && this.state === "shop") return;

    const c = this.ctx;
    const watch = this.spectateTarget();
    c.save();
    c.font = uiFont(600, "md");
    c.textAlign = "center";
    c.textBaseline = "top";
    c.fillStyle = "#7ec8e3";
    if (this.matchMode === "sandbox") {
      c.fillText("SPECTATING", this.cx, 14);
    } else {
      const who = watch
        ? (watch.colorName || watch.name) + playerBotTag(watch)
        : "—";
      const title = this.roundSpectate && !this.spectating
        ? `ELIMINATED — ROUND ${this.roundNumber} / ${this.matchRounds}`
        : `SPECTATING — ROUND ${this.roundNumber} / ${this.matchRounds}`;
      c.fillText(title, this.cx, 14);
      if (this.state === "playing" || this.state === "countdown" || this.state === "roundover") {
        c.font = uiFont(600, "base");
        c.fillStyle = "#b6d8ea";
        c.fillText(`Viewing ${who}`, this.cx, 34);
      }
    }

    // wins standings top-left (eye marks watched player)
    c.textAlign = "left";
    const y0 = this.state === "shop" ? CFG.hudWinsBaseY : Math.max(CFG.hudWinsBaseY, 68);
    this.drawStandingsBlock(c, 32, y0, this.spectateWatchId);

    // watched player gold + damage (same corner stack as player HUD)
    if (watch && this.state === "playing") {
      const hud = this.matchHudCorner();
      const rx = this.W - 16;
      c.textAlign = "right";
      if (hud.goldY != null) {
        c.fillStyle = "#ffd479";
        c.font = uiFont(600, "md");
        c.fillText(`✦ ${watch.gold}g`, rx, hud.goldY);
      }
      c.fillStyle = "#ff9a5a";
      c.font = uiFont(600, "base");
      c.fillText(`DMG ${Math.round(watch.dmgDealt || 0)}  ·  ${watch.kills || 0} KO`, rx, hud.dmgY);
    }

    c.restore();

    this.updateSpectateHud();

    if (watch && this.state === "playing") this.drawSpellBar(watch, true);
  }

Game.prototype.actionBarVisible = function () {
    if (this.state === "shop" && !this.spectating && this.human()) return true;
    const inMatch = this.state === "playing" || this.state === "countdown"
      || this.state === "roundover" || this.state === "bossintro";
    return inMatch && (this.human() || this.inSpectateView());
  }

/** Extra viewport inset (px) for spell bar + shift+drag hint — keeps bottom HUD off the edge. */
const SPELL_BAR_LIFT = 20;

Game.prototype.spellBarLayout = function () {
    const scale = 0.6;
    const size = 58 * scale, gap = 7 * scale, rowGap = 6 * scale;
    const hintGap = 8 * scale, hintBottomGap = 4 * scale;
    const fullRowWidth = 4 * size + 3 * gap;
    const stagger = (size + gap) * 0.5;
    const ySpace = this.H - 74 * scale - hintBottomGap - SPELL_BAR_LIFT;
    const yBottom = ySpace - size - rowGap;
    const yTop = yBottom - size - rowGap;
    const barH = 3 * size + 2 * rowGap; // primary + secondary + space rows
    const primaryX = this.cx - fullRowWidth / 2;
    const secondaryX = primaryX + stagger;
    const spaceX = primaryX;
    const spaceW = secondaryX + fullRowWidth - primaryX;
    const spaceBoxX = spaceX + (spaceW - size) / 2;
    const vialW = 64 * scale, vialGap = 12 * scale;
    const vialH = barH;
    const vialX = primaryX - vialGap - vialW;
    const vialY = yTop;
    return {
      size, gap, rowGap, hintGap, hintBottomGap, lift: SPELL_BAR_LIFT,
      yTop, yBottom, ySpace,
      primaryX, secondaryX,
      primarySlots: ["1", "2", "3", "4"],
      secondarySlots: ["Q", "W", "E", "R"],
      spaceSlot: "Space",
      spaceX, spaceW, spaceBoxX,
      vialX, vialY, vialW, vialH, vialGap,
    };
  }

Game.prototype.hpVialPath = function (x, y, w, h) {
    const c = this.ctx;
    const lip = w * 0.07;
    const m = w * 0.15;
    const l = x + m;
    const r = x + w - m;
    const lipL = x + m - lip;
    const lipR = x + w - m + lip;
    const cx = x + w / 2;
    const rw = (r - l) / 2;
    const top = y + m * 0.25;
    const bot = y + h - m * 0.45;
    const bowlCy = bot - rw * 0.35;
    c.beginPath();
    c.moveTo(lipL, top);
    c.lineTo(lipR, top);
    c.lineTo(r, top + m * 0.45);
    c.lineTo(r, bowlCy);
    c.arc(cx, bowlCy, rw, 0, Math.PI, false);
    c.lineTo(l, top + m * 0.45);
    c.closePath();
  }

Game.prototype.tickHpVial = function (dt, p) {
    const max = p.effMaxHP ? p.effMaxHP() : CFG.maxHP;
    const target = (!p.alive || p.falling) ? 0 : clamp(p.hp / max, 0, 1);
    if (p.id !== this._hpVialPid) {
      this._hpVialPid = p.id;
      this._hpVialFrac = target;
      this._hpVialVel = 0;
      this._hpVialSlosh = 0;
      return;
    }
    const prev = this._hpVialFrac;
    const draining = target < this._hpVialFrac - 0.0005;
    const speed = draining ? 5.5 : 14;
    this._hpVialFrac += (target - this._hpVialFrac) * clamp(dt * speed, 0, 1);
    const instVel = (this._hpVialFrac - prev) / Math.max(dt, 1e-4);
    this._hpVialVel = lerp(this._hpVialVel || 0, instVel, clamp(dt * 16, 0, 1));
    const activity = Math.abs(this._hpVialVel) * 3.2 + Math.abs(target - this._hpVialFrac) * 2.2;
    this._hpVialSlosh = Math.max(activity, (this._hpVialSlosh || 0) * (1 - dt * 4));
  }

/** Wavy liquid surface — gentle ripples; a touch stronger while the fill level moves. */
Game.prototype.hpVialWaveY = function (px, fillL, fillW, baseY, t, slosh, vel) {
    const nx = (px - fillL) / fillW;
    const idle = 1.1 + Math.sin(t * 2.4) * 0.35;
    const amp = idle + slosh * fillW * 0.055;
    const spd = 4.8 + slosh * 3.2;
    const wave = amp * (
      Math.sin(nx * TAU * 2.1 + t * spd) * 0.62 +
      Math.sin(nx * TAU * 3.6 - t * spd * 0.85 + 0.9) * 0.38
    );
    const tilt = vel * fillW * 0.22 * (nx - 0.5) * 2;
    return baseY + wave + tilt;
  }

Game.prototype.hpVialFillGeom = function (x, y, w, h) {
    const m = w * 0.15;
    const fillL = x + m;
    const fillR = x + w - m;
    const fillW = fillR - fillL;
    const fillRw = fillW / 2;
    const fillCx = x + w / 2;
    const top = y + m * 0.25;
    const bot = y + h - m * 0.45;
    const fillTop = top + m * 0.55;
    const fillBowlCy = bot - fillRw * 0.35;
    const fillBottom = fillBowlCy + fillRw;
    const fillH = fillBottom - fillTop;
    return { fillL, fillR, fillW, fillRw, fillCx, fillTop, fillBowlCy, fillBottom, fillH };
  }

/** Wavy top, sides down to the glass floor — vial clip rounds the bottom concave. */
Game.prototype.hpVialLiquidPath = function (geom, liquidTop, t, slosh, vel) {
    const c = this.ctx;
    const { fillL, fillR, fillW, fillBottom } = geom;
    const steps = Math.max(10, Math.round(fillW / 2.5));
    const waveAt = (px) => this.hpVialWaveY(px, fillL, fillW, liquidTop, t, slosh, vel);
    c.beginPath();
    c.moveTo(fillR, waveAt(fillR));
    for (let i = steps - 1; i >= 0; i--) {
      const px = fillL + (fillW * i) / steps;
      c.lineTo(px, waveAt(px));
    }
    c.lineTo(fillL, fillBottom);
    c.lineTo(fillR, fillBottom);
    c.closePath();
  }

Game.prototype.drawHpVial = function (p, lay, dt) {
    const c = this.ctx;
    const { vialX: x, vialY: y, vialW: w, vialH: h } = lay;
    this.tickHpVial(dt, p);
    const frac = clamp(this._hpVialFrac, 0, 1);
    const slosh = this._hpVialSlosh || 0;
    const vel = this._hpVialVel || 0;
    const waveT = this.nowS;
    const pulse = p.hemorrhageT > 0 ? 0.5 + 0.5 * Math.sin(this.now / 70) : 0;
    const lowHpDanger = this.playerLowHpDanger?.(p) ? 0.35 + 0.25 * Math.sin(this.now / 90) : 0;

    c.save();

    // soft drop shadow
    c.fillStyle = "rgba(0,0,0,0.35)";
    this.hpVialPath(x + 2, y + 3, w, h);
    c.fill();

    // clip to vial interior for blood
    this.hpVialPath(x, y, w, h);
    c.save();
    c.clip();

    const geom = this.hpVialFillGeom(x, y, w, h);
    const { fillL, fillR, fillW, fillTop, fillBottom, fillH } = geom;
    const liquidTop = fillBottom - fillH * frac;

    if (frac > 0.002) {
      // palette matches arena bloodStains — oxygenated surface, venous body, clot-dark pool
      const surface = pulse > 0.35 ? "#e42838" : lowHpDanger > 0.25 ? "#9a1828" : "#c41e2e";
      const body = lowHpDanger > 0.25 ? "#6a0c14" : "#861420";
      const g = c.createLinearGradient(0, liquidTop - fillW * 0.12, 0, fillBottom);
      g.addColorStop(0, surface);
      g.addColorStop(0.1, "#a81824");
      g.addColorStop(0.42, body);
      g.addColorStop(0.78, "#580c14");
      g.addColorStop(1, "#3a0508");
      this.hpVialLiquidPath(geom, liquidTop, waveT, slosh, vel);
      c.fillStyle = g;
      c.fill();

      // viscosity depth — thin bright film on the left, shadowed through glass on the right
      this.hpVialLiquidPath(geom, liquidTop, waveT, slosh, vel);
      const depth = c.createLinearGradient(fillL, 0, fillR, 0);
      depth.addColorStop(0, "rgba(255,200,200,0.07)");
      depth.addColorStop(0.4, "rgba(0,0,0,0)");
      depth.addColorStop(1, "rgba(20,0,0,0.28)");
      c.fillStyle = depth;
      c.fill();

      // wet meniscus along the wavy surface
      c.beginPath();
      const shineSteps = Math.max(10, Math.round(fillW / 2.5));
      for (let i = 0; i <= shineSteps; i++) {
        const px = fillL + (fillW * i) / shineSteps;
        const wy = this.hpVialWaveY(px, fillL, fillW, liquidTop, waveT, slosh, vel);
        if (i === 0) c.moveTo(px, wy);
        else c.lineTo(px, wy);
      }
      c.strokeStyle = `rgba(${pulse > 0.35 ? "220,50,60" : "170,30,40"},${0.28 + 0.16 * slosh + 0.12 * pulse})`;
      c.lineWidth = 1.1 + slosh * 0.65;
      c.stroke();

      // subsurface highlight band just under the waves while sloshing
      if (slosh > 0.28) {
        c.save();
        this.hpVialLiquidPath(geom, liquidTop + fillW * 0.06, waveT + 0.08, slosh * 0.55, vel);
        c.clip();
        c.fillStyle = `rgba(120,18,28,${0.05 + slosh * 0.05})`;
        c.fillRect(fillL, liquidTop - fillW * 0.15, fillW, fillW * 0.35);
        c.restore();
      }

      // slow bubble shimmer inside blood
      if (frac > 0.08) {
        const bubY = fillBottom - fillH * frac * (0.25 + 0.5 * (0.5 + 0.5 * Math.sin(this.nowS * 1.7)));
        c.fillStyle = "rgba(90,12,20,0.18)";
        c.beginPath();
        c.arc(x + w * 0.38, bubY, w * 0.07, 0, TAU);
        c.fill();
      }
    }

    // empty chamber above the blood (clip follows the same wave when liquid is present)
    if (frac < 0.995) {
      c.fillStyle = "rgba(8,6,18,0.28)";
      if (frac > 0.002) {
        c.beginPath();
        c.moveTo(fillL, fillTop);
        c.lineTo(fillR, fillTop);
        c.lineTo(fillR, liquidTop + fillW * 0.25);
        const airSteps = Math.max(8, Math.round(fillW / 3));
        for (let i = airSteps; i >= 0; i--) {
          const px = fillL + (fillW * i) / airSteps;
          c.lineTo(px, this.hpVialWaveY(px, fillL, fillW, liquidTop, waveT, slosh, vel) + fillW * 0.18);
        }
        c.closePath();
        c.fill();
      } else {
        c.fillRect(fillL, fillTop, fillW, fillH);
      }
    }

    c.restore();

    // glass body tint
    const glass = c.createLinearGradient(x, y, x + w, y);
    glass.addColorStop(0, "rgba(210,228,255,0.16)");
    glass.addColorStop(0.45, "rgba(170,190,230,0.06)");
    glass.addColorStop(1, "rgba(40,30,70,0.18)");
    this.hpVialPath(x, y, w, h);
    c.fillStyle = glass;
    c.fill();

    // left specular streak
    c.save();
    this.hpVialPath(x, y, w, h);
    c.clip();
    const spec = c.createLinearGradient(x + w * 0.2, y, x + w * 0.45, y + h);
    spec.addColorStop(0, "rgba(255,255,255,0.38)");
    spec.addColorStop(0.5, "rgba(255,255,255,0.08)");
    spec.addColorStop(1, "rgba(255,255,255,0)");
    c.fillStyle = spec;
    c.fillRect(x, y, w * 0.55, h);
    c.restore();

    // glass outline + lip
    this.hpVialPath(x, y, w, h);
    c.strokeStyle = "rgba(190,210,245,0.55)";
    c.lineWidth = 1.5;
    c.stroke();
    const lipY = y + w * 0.15 * 0.25;
    c.beginPath();
    c.moveTo(x + w * 0.08, lipY);
    c.lineTo(x + w * 0.92, lipY);
    c.strokeStyle = "rgba(220,235,255,0.7)";
    c.lineWidth = 2;
    c.stroke();

    c.restore();
  }

Game.prototype.clientToCanvas = function (clientX, clientY) {
    const cr = this.canvas.getBoundingClientRect();
    const sx = this.canvas.width / cr.width;
    const sy = this.canvas.height / cr.height;
    return {
      x: (clientX - cr.left) * sx,
      y: (clientY - cr.top) * sy,
    };
  }


Game.prototype.spellBarSlotAt = function (clientX, clientY) {
    if (!this.actionBarVisible()) return null;
    const p = this.spellBarPlayer();
    if (!p) return null;
    const { x, y } = this.clientToCanvas(clientX, clientY);
    const lay = this.spellBarLayout();
    const rows = [
      { slots: lay.primarySlots, x0: lay.primaryX, y: lay.yTop },
      { slots: lay.secondarySlots, x0: lay.secondaryX, y: lay.yBottom },
    ];
    for (const row of rows) {
      for (let i = 0; i < row.slots.length; i++) {
        const slot = row.slots[i];
        const sx = row.x0 + i * (lay.size + lay.gap);
        const sy = row.y;
        if (x < sx || x > sx + lay.size || y < sy || y > sy + lay.size) continue;
        const spellId = p.loadout[slot];
        return {
          slot, x: sx, y: sy, w: lay.size, h: lay.size,
          spellId: spellId && SPELLS[spellId] ? spellId : "",
        };
      }
    }
    if (x >= lay.spaceX && x <= lay.spaceX + lay.spaceW &&
        y >= lay.ySpace && y <= lay.ySpace + lay.size) {
      const slot = lay.spaceSlot;
      const spellId = p.loadout[slot];
      return {
        slot, x: lay.spaceBoxX, y: lay.ySpace, w: lay.size, h: lay.size,
        spellId: spellId && SPELLS[spellId] ? spellId : "",
        wideX: lay.spaceX, wideW: lay.spaceW,
      };
    }
    return null;
  }

Game.prototype.spellBarHitSlot = function (clientX, clientY) {
    if (!this.actionBarVisible()) return null;
    const p = this.spellBarPlayer();
    if (!p) return null;
    const { x, y } = this.clientToCanvas(clientX, clientY);
    // Prefer last-drawn slot rects (same pixels as drawSpellBar); layout fallback before first paint.
    const slots = this.spellBarSlots;
    if (slots && slots.length) {
      for (const sl of slots) {
        if (x < sl.x || x > sl.x + sl.w || y < sl.y || y > sl.y + sl.h) continue;
        return {
          x: sl.x, y: sl.y, w: sl.w, h: sl.h, id: sl.id,
          synergyId: sl.synergyId || "",
        };
      }
    }
    const hit = this.spellBarSlotAt(clientX, clientY);
    if (!hit || !hit.spellId) return null;
    const id = hit.spellId;
    const syn = activeSynergyForSpell(p.loadout, p.committed, p.passives, id);
    return {
      x: hit.x, y: hit.y, w: hit.w, h: hit.h, id,
      synergyId: syn?.id || "",
    };
  }

/** 1234 / QWER action bar — hotkey slot only (tooltip is display-only). */
Game.prototype.overActionBarTip = function (x, y) {
    return !!this.spellBarHitSlot(x, y);
  }

Game.prototype.clearSpellBarTip = function () {
    this.barTipKey = null;
    Tip.hide();
  }

Game.prototype.updateSpellBarHover = function (x, y) {
    if (!this.actionBarVisible()) {
      if (this.barTipKey) this.clearSpellBarTip();
      return;
    }
    const shop = document.getElementById("shop");
    const spellbook = document.getElementById("spellbook");
    const hit = this.spellBarHitSlot(x, y);
    if (((shop && !shop.classList.contains("hidden")) ||
        (spellbook && !spellbook.classList.contains("hidden"))) && !hit) {
      if (this.barTipKey) this.clearSpellBarTip();
      return;
    }
    if (!hit) {
      if (this.barTipKey) this.clearSpellBarTip();
      return;
    }
    const p = this.spellBarPlayer();
    const key = hit.id + ":" + (hit.synergyId || "");
    const tipOpts = { preferAbove: true };
    if (key !== this.barTipKey) {
      this.statusTipKey = null;
      this.barTipKey = key;
      Tip.show(spellBarTipHTML(hit.id, p), x, y, tipOpts);
    } else {
      scheduleTipMove(x, y, tipOpts);
    }
  }

Game.prototype.spellBarPlayer = function () {
    if (this.state === "shop" && !this.spectating) return this.human();
    if (this.state === "playing" && this.inSpectateView()) {
      return this.players.find(p => p.id === this.spectateWatchId) || null;
    }
    return this.human();
  }

Game.prototype.drawLowHpOverlay = function (c) {
    const pulse = 0.5 + 0.5 * Math.sin(this.now / 90);
    c.save();
    const vg = c.createRadialGradient(this.cx, this.cy, Math.min(this.W, this.H) * 0.3,
      this.cx, this.cy, Math.max(this.W, this.H) * 0.6);
    vg.addColorStop(0, "rgba(255,0,0,0)");
    vg.addColorStop(1, `rgba(255,0,0,${0.18 + 0.12 * pulse})`);
    c.fillStyle = vg;
    c.fillRect(0, 0, this.W, this.H);
    c.restore();
  }

Game.prototype.essenceAttuneState = function (p) {
    if (!p?.essenceMark) return null;
    const light = p.essenceMark === 1;
    const effects = this.inSpectateView?.() ? this._watchEffects : this._myEffects;
    const fxId = light ? "essence_light" : "essence_void";
    const fx = (effects || []).find(e => e.id === fxId);
    const now = performance.now();
    const rem = fx ? Math.max(0, fx.rem - (now - fx.at) / 1000) : 0;
    return { light, rem };
  }

Game.prototype.drawEssenceAttuneOverlay = function (c, state) {
    const pulse = 0.5 + 0.5 * Math.sin(this.now / 110);
    const expiring = state.rem > 0 && state.rem < 3;
    const urgency = expiring ? 0.35 + 0.25 * pulse : 0;
    const baseA = expiring ? 0.22 + urgency : 0.14 + 0.06 * pulse;
    const gx = this.cx;
    const gy = this.cy;
    const dim = Math.min(this.W, this.H);
    const cornerR = Math.hypot(Math.max(gx, this.W - gx), Math.max(gy, this.H - gy));
    const outerR = cornerR * 1.12;
    const clearR = dim * 0.34;

    c.save();
    const ring = c.createRadialGradient(gx, gy, clearR, gx, gy, outerR);
    if (state.light) {
      ring.addColorStop(0, "rgba(0,0,0,0)");
      ring.addColorStop(0.42, "rgba(0,0,0,0)");
      ring.addColorStop(0.62, `rgba(255, 196, 64, ${baseA * 0.35})`);
      ring.addColorStop(0.82, `rgba(255, 168, 32, ${baseA * 0.72})`);
      ring.addColorStop(1, `rgba(255, 140, 16, ${baseA * 0.92})`);
    } else {
      ring.addColorStop(0, "rgba(0,0,0,0)");
      ring.addColorStop(0.42, "rgba(0,0,0,0)");
      ring.addColorStop(0.62, `rgba(120, 48, 180, ${baseA * 0.38})`);
      ring.addColorStop(0.82, `rgba(88, 24, 140, ${baseA * 0.74})`);
      ring.addColorStop(1, `rgba(56, 8, 96, ${baseA * 0.95})`);
    }
    c.fillStyle = ring;
    c.fillRect(0, 0, this.W, this.H);

    const cornerReach = dim * 0.46;
    const cornerA = baseA * 0.85;
    const cornerStops = state.light
      ? ["rgba(255, 210, 96,", "rgba(255, 168, 48,", "rgba(200, 120, 24,"]
      : ["rgba(140, 64, 200,", "rgba(96, 32, 148,", "rgba(64, 16, 104,"];
    for (const [cx, cy] of [[0, 0], [this.W, 0], [0, this.H], [this.W, this.H]]) {
      const cg = c.createRadialGradient(cx, cy, 0, cx, cy, cornerReach);
      cg.addColorStop(0, `${cornerStops[0]}${cornerA})`);
      cg.addColorStop(0.34, `${cornerStops[1]}${cornerA * 0.55})`);
      cg.addColorStop(0.7, `${cornerStops[2]}${cornerA * 0.18})`);
      cg.addColorStop(1, "rgba(0,0,0,0)");
      c.fillStyle = cg;
      c.fillRect(cx - cornerReach, cy - cornerReach, cornerReach * 2, cornerReach * 2);
    }

    const label = state.light ? "LIGHT ATTUNED" : "VOID ATTUNED";
    const labelCol = state.light ? "#ffe8a0" : "#ddb8ff";
    const labelGlow = state.light ? "rgba(255, 196, 64, 0.55)" : "rgba(160, 80, 220, 0.55)";
    c.font = uiFont(700, "sm");
    c.textAlign = "center";
    c.textBaseline = "top";
    c.shadowColor = labelGlow;
    c.shadowBlur = 12 + 6 * pulse;
    c.fillStyle = labelCol;
    c.globalAlpha = 0.82 + 0.12 * pulse;
    c.fillText(label, gx, 18);
    c.restore();
  }

Game.prototype.drawEssencePulseOverlay = function (c, pulseLight) {
    const ec = this.essenceCast;
    if (!ec?.pl || ec.ph === "recover" || ec.k !== "bloom") return;
    const pulse = 0.5 + 0.5 * Math.sin(this.now / 95);
    const until = this.essenceCastProgress?.()?.untilPulse ?? ec.t ?? 0;
    const urgent = until > 0 && until < 0.8;
    const baseA = urgent ? 0.2 + 0.12 * pulse : 0.12 + 0.06 * pulse;
    const gx = this.cx;
    const gy = this.cy;
    const dim = Math.min(this.W, this.H);
    const cornerR = Math.hypot(Math.max(gx, this.W - gx), Math.max(gy, this.H - gy));
    const outerR = cornerR * 1.1;
    const clearR = dim * 0.38;

    c.save();
    const ring = c.createRadialGradient(gx, gy, clearR, gx, gy, outerR);
    if (pulseLight) {
      ring.addColorStop(0, "rgba(0,0,0,0)");
      ring.addColorStop(0.5, "rgba(0,0,0,0)");
      ring.addColorStop(0.72, `rgba(255, 200, 80, ${baseA * 0.45})`);
      ring.addColorStop(1, `rgba(255, 160, 32, ${baseA * 0.85})`);
    } else {
      ring.addColorStop(0, "rgba(0,0,0,0)");
      ring.addColorStop(0.5, "rgba(0,0,0,0)");
      ring.addColorStop(0.72, `rgba(140, 64, 200, ${baseA * 0.48})`);
      ring.addColorStop(1, `rgba(72, 24, 120, ${baseA * 0.88})`);
    }
    c.fillStyle = ring;
    c.fillRect(0, 0, this.W, this.H);
    c.restore();
  }

Game.prototype.dangerOverlaySubject = function () {
    const st = this.state;
    if (st !== "playing" && st !== "countdown" && st !== "roundover") return null;
    if (this.inSpectateView()) return this.spectateTarget();
    const p = this.human();
    if (!p || !p.alive || p.falling) return null;
    return p;
  }

/** Screen-space danger vignettes — after arena, before HUD. */
Game.prototype.drawDangerOverlays = function () {
    const p = this.dangerOverlaySubject();
    if (!p) return;
    const c = this.ctx;
    if (p.outside) this.drawVoidClosingOverlay(c, p);
    const ec = this.essenceCast;
    if (ec?.n && ec.ph !== "recover" && ec.k === "bloom" && ec.ph === "telegraph") {
      this.drawEssencePulseOverlay(c, ec.n === 1);
    }
    const essence = this.essenceAttuneState(p);
    if (essence && (!ec?.n || p.essenceMark === ec.n)) {
      this.drawEssenceAttuneOverlay(c, essence);
    }
    if (this.playerLowHpDanger(p)) this.drawLowHpOverlay(c);
  }

Game.prototype.drawVoidClosingOverlay = function (c, p) {
    const tight = this.voidOverlayTightness(p);
    const gx = this.cx;
    const gy = this.cy;
    const dim = Math.min(this.W, this.H);
    const cornerR = Math.hypot(Math.max(gx, this.W - gx), Math.max(gy, this.H - gy));
    const outerR = cornerR * 1.14;
    const clearR = lerp(cornerR, 0, tight);
    const edgeA = 0.72 + 0.28 * tight;

    c.save();

    const ring = c.createRadialGradient(gx, gy, clearR, gx, gy, outerR);
    ring.addColorStop(0, "rgba(0,0,0,0)");
    ring.addColorStop(0.28, "rgba(0,0,0,0)");
    ring.addColorStop(0.48, `rgba(8, 2, 18, ${edgeA * 0.12})`);
    ring.addColorStop(0.68, `rgba(6, 0, 14, ${edgeA * 0.38})`);
    ring.addColorStop(0.86, `rgba(4, 0, 12, ${edgeA * 0.72})`);
    ring.addColorStop(1, `rgba(2, 0, 8, ${edgeA * 0.95})`);
    c.fillStyle = ring;
    c.fillRect(0, 0, this.W, this.H);

    const cornerReach = lerp(dim * 0.38, dim * 0.58, tight);
    const cornerA = edgeA * 0.62;
    for (const [cx, cy] of [[0, 0], [this.W, 0], [0, this.H], [this.W, this.H]]) {
      const cg = c.createRadialGradient(cx, cy, 0, cx, cy, cornerReach);
      cg.addColorStop(0, `rgba(2, 0, 8, ${cornerA})`);
      cg.addColorStop(0.32, `rgba(4, 0, 12, ${cornerA * 0.58})`);
      cg.addColorStop(0.68, `rgba(6, 0, 14, ${cornerA * 0.2})`);
      cg.addColorStop(1, "rgba(0,0,0,0)");
      c.fillStyle = cg;
      c.fillRect(cx - cornerReach, cy - cornerReach, cornerReach * 2, cornerReach * 2);
    }

    if (tight > 0.02) {
      const soft = dim * lerp(0.06, 0.16, tight);
      const haze = c.createRadialGradient(gx, gy, Math.max(0, clearR - soft), gx, gy, clearR + soft * 0.35);
      haze.addColorStop(0, "rgba(0,0,0,0)");
      haze.addColorStop(0.45, "rgba(0,0,0,0)");
      haze.addColorStop(0.78, `rgba(14, 4, 30, ${edgeA * 0.22 * tight})`);
      haze.addColorStop(1, `rgba(10, 2, 22, ${edgeA * 0.34 * tight})`);
      c.fillStyle = haze;
      c.fillRect(0, 0, this.W, this.H);
    }

    c.restore();
  }

Game.prototype.drawSpellBar = function (p, spectating, draftMode) {
    const c = this.ctx;
    const lay = this.spellBarLayout();
    const { size, gap, yTop, yBottom, ySpace, primaryX, secondaryX, spaceSlot, spaceX, spaceW, spaceBoxX } = lay;
    const dt = this._hpVialLastNow
      ? Math.min((this.now - this._hpVialLastNow) / 1000, 0.05)
      : 1 / 60;
    this._hpVialLastNow = this.now;
    this.drawHpVial(p, lay, dt);

    this.spellBarSlots = [];   // rebuilt each frame for hover tooltips
    const draggingFrom = this.slotDrag?.from || null;
    lay.primarySlots.forEach((slot, i) => {
      const x = primaryX + i * (size + gap);
      const id = p.loadout[slot];
      if (slot === draggingFrom) this.drawEmptySpellSlot(x, yTop, slot, size);
      else if (id && SPELLS[id]) this.drawSpellSlot(x, yTop, slot, id, p, size, draftMode);
      else this.drawEmptySpellSlot(x, yTop, slot, size);
    });

    lay.secondarySlots.forEach((slot, i) => {
      const x = secondaryX + i * (size + gap);
      const id = p.loadout[slot];
      if (slot === draggingFrom) this.drawEmptySpellSlot(x, yBottom, slot, size);
      else if (id && SPELLS[id]) this.drawSpellSlot(x, yBottom, slot, id, p, size, draftMode);
      else this.drawEmptySpellSlot(x, yBottom, slot, size);
    });

    this.drawSpaceSpellSlot(p, lay, draftMode, draggingFrom === spaceSlot);

    this.drawSpellBarHint(lay);
    if (typeof this.drawSlotDragOverlay === "function") this.drawSlotDragOverlay();

    if (draftMode) return;

    const barScale = lay.size / 58;
    const warnY = Math.min(this.H - 224 * barScale, lay.yTop - 60 * barScale);
    const warnSubY = warnY + 28 * barScale;

    // dead / void overlay
    if (!p.alive || p.falling) {
      if (!spectating) {
        c.save();
        c.textAlign = "center"; c.textBaseline = "middle";
        c.font = uiFont(700, "2xl");
        c.fillStyle = "rgba(255,90,90,0.9)";
        c.fillText(p.outside ? "YOU FELL INTO THE VOID" : "YOU ARE SLAIN", this.cx, warnY);
        c.font = uiFont(500, "md");
        c.fillStyle = "#b6afdc";
        c.fillText("Spectating… round ends when one warlock remains", this.cx, warnSubY);
        c.restore();
      }
    } else if (this.playerInVoidDanger(p)) {
        const rip = !p.outside && this.playerInVoidRipCore(p);
        const pulse = 0.5 + 0.5 * Math.sin(this.now / 90);
        const voidWarnY = this.H * 0.175;
        c.save();
        c.textAlign = "center"; c.textBaseline = "middle";
        c.font = uiFont(700, "xl");
        c.fillStyle = `rgba(255,${80 + 60 * pulse},80,0.95)`;
        const warn = rip
          ? (spectating ? "⚠ VOID RIP — WIZARD IN THE TEAR! ⚠" : "⚠ VOID RIP — GET OUT OF THE TEAR! ⚠")
          : (spectating ? "⚠ OVER THE VOID — WIZARD OFF THE PLATFORM! ⚠" : "⚠ OVER THE VOID — GET BACK ON THE PLATFORM! ⚠");
        c.fillText(warn, this.cx, voidWarnY);
        c.restore();
    }
  }

Game.prototype.spellBarSlotRadius = function (size) {
    return size * (10 / 58);
  }

Game.prototype.spellBarKeyFont = function (size) {
    return uiFont(600, size < 40 ? "2xs" : "xs");
  }

Game.prototype.spellBarCdFont = function (size) {
    return uiFont(600, size < 40 ? "xs" : "base");
  }

Game.prototype.drawSpaceSpellSlot = function (p, lay, draftMode, dragging) {
    const c = this.ctx;
    const { size, spaceSlot, spaceX, spaceW, spaceBoxX, ySpace } = lay;
    const id = p.loadout[spaceSlot];
    const r = this.spellBarSlotRadius(size);
    const pad = size * (5 / 58);

    c.save();
    c.fillStyle = "rgba(12,10,26,0.55)";
    c.strokeStyle = "rgba(80,72,110,0.35)";
    c.lineWidth = Math.max(1, size * (2 / 58));
    this.roundRect(spaceX, ySpace, spaceW, size, r);
    c.fill(); c.stroke();
    c.font = this.spellBarKeyFont(size);
    c.textAlign = "left"; c.textBaseline = "top";
    c.fillStyle = "rgba(120,112,150,0.55)";
    c.fillText(keyLabelForSlot(spaceSlot), spaceX + pad + size * (3 / 58), ySpace + pad);
    c.restore();

    if (dragging) {
      this.drawSpaceCenterPlaceholder(spaceBoxX, ySpace, size);
      return;
    }
    if (id && SPELLS[id]) this.drawSpellSlot(spaceBoxX, ySpace, spaceSlot, id, p, size, draftMode);
    else this.drawSpaceCenterPlaceholder(spaceBoxX, ySpace, size);
  }

Game.prototype.drawSpaceCenterPlaceholder = function (x, y, size) {
    const c = this.ctx;
    c.save();
    c.strokeStyle = "rgba(80,72,110,0.35)";
    c.lineWidth = Math.max(1, size * (2 / 58));
    this.roundRect(x, y, size, size, this.spellBarSlotRadius(size));
    c.stroke();
    c.restore();
  }

Game.prototype.drawSpellSlot = function (x, y, slot, id, p, size, draftMode) {
    const c = this.ctx;
    const s = SPELLS[id];
    if (!s) return;
    const syn = activeSynergyForSpell(p.loadout, p.committed, p.passives, id);
    const synergyId = syn?.id || "";
    if (this.spellBarSlots) {
      this.spellBarSlots.push({ x, y, w: size, h: size, id, synergyId });
    }
    const noCD = draftMode || (this.sandboxNoCD && p.isHuman);
    const cd = noCD ? 0 : (p.cd[id] || 0);
    const ready = cd <= 0;
    const cdMax = p.cdOverlayMax(id);
    const frac = ready ? 0 : clamp(cd / cdMax, 0, 1);

    const pad = size * (5 / 58);
    const icOff = size * (3 / 58);
    const r = this.spellBarSlotRadius(size);
    const lw = Math.max(1, size * (2 / 58));

    c.save();
    c.fillStyle = "rgba(15,12,32,0.8)";
    c.strokeStyle = synergyId
      ? (ready ? "#e8b84a" : "rgba(180,150,80,0.55)")
      : (ready ? s.color : "rgba(120,110,170,0.4)");
    c.lineWidth = synergyId ? lw * 1.25 : lw;
    this.roundRect(x, y, size, size, r);
    c.fill(); c.stroke();

    c.globalAlpha = ready ? 1 : 0.45;
    const icX = x + size / 2;
    const icY = y + size / 2 - icOff;
    const iconScale = synergyId ? 0.94 : 0.88;
    drawBarIcon(c, icX, icY, size * iconScale, id, synergyId);
    c.globalAlpha = 1;

    if (!ready) {
      c.fillStyle = "rgba(0,0,0,0.6)";
      c.fillRect(x + 1, y + 1, size - 2, (size - 2) * frac);
      c.fillStyle = "#fff";
      c.font = this.spellBarCdFont(size);
      c.textAlign = "center"; c.textBaseline = "middle";
      c.fillText(cd.toFixed(1), x + size / 2, y + size / 2 - icOff);
    }

    // key label
    c.font = this.spellBarKeyFont(size);
    c.textAlign = "left"; c.textBaseline = "top";
    c.fillStyle = "#cfc9f0";
    c.fillText(keyLabelForSlot(slot), x + pad, y + pad * 0.8);
    c.restore();
  }

Game.prototype.drawSpellBarHint = function (lay) {
    if (!this.slotReorderAllowed?.()) return;
    const c = this.ctx;
    c.save();
    c.textAlign = "center";
    c.textBaseline = "top";
    c.font = uiFont(500, "xs");
    c.fillStyle = "rgba(182,175,220,0.65)";
    c.fillText("Shift + drag to move skills", this.cx, lay.ySpace + lay.size + lay.hintGap);
    c.restore();
  }

Game.prototype.drawEmptySpellSlot = function (x, y, slot, size) {
    const c = this.ctx;
    const pad = size * (5 / 58);
    c.save();
    c.fillStyle = "rgba(12,10,26,0.55)";
    c.strokeStyle = "rgba(80,72,110,0.35)";
    c.lineWidth = Math.max(1, size * (2 / 58));
    this.roundRect(x, y, size, size, this.spellBarSlotRadius(size));
    c.fill(); c.stroke();

    c.font = this.spellBarKeyFont(size);
    c.textAlign = "left"; c.textBaseline = "top";
    c.fillStyle = "rgba(120,112,150,0.55)";
    c.fillText(keyLabelForSlot(slot), x + pad, y + pad * 0.8);
    c.restore();
  }

Game.prototype.roundRect = function (x, y, w, h, r) {
    const c = this.ctx;
    c.beginPath();
    c.moveTo(x + r, y);
    c.arcTo(x + w, y, x + w, y + h, r);
    c.arcTo(x + w, y + h, x, y + h, r);
    c.arcTo(x, y + h, x, y, r);
    c.arcTo(x, y, x + w, y, r);
    c.closePath();
  }
